import { url } from 'constants/index';

export const urlByCompetitorTypeMapping = {
  Team: url.teams,
  Player: url.players,
  DoublesPartnership: url.doubles,
  Double: url.doubles,
  Person: url.persons,
};
export const urlByCompetitorTypeMappingRouting = {
  Team: url.base_teams,
  Player: url.base_players,
  DoublesPartnership: url.base_doubles,
  Double: url.base_doubles,
  Person: url.base_persons,
  TBD: url.base_tbds,
};
